import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  // State to track which FAQ items are expanded
  const [expandedItems, setExpandedItems] = useState({});

  // Toggle function for expanding/collapsing FAQ items
  const toggleItem = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // FAQ data structure
  const faqItems = [
    {
      id: 1,
      question: "What is this site about?",
      answer: "This site started as a passion project born from a love of anime and its community. It's designed to be versatile and user-driven - you can use it to discover new anime and manga, track your watch/read lists, write reviews, participate in discussions, and connect with other anime enthusiasts. We believe in creating a space that serves the community in whatever way they find most valuable."
    },
    {
      id: 2,
      question: "Do I need an account to use this site?",
      answer: "No, you don't need an account to browse our extensive collection of anime, manga, and character information. However, creating a free account unlocks all features including personalized tracking lists, the ability to write reviews, participate in discussions, and customize your profile to showcase your anime journey."
    },
    {
      id: 3,
      question: "How do you handle age-restricted or explicit content?",
      answer: "We display clear content badges to indicate when material contains explicit themes. These warnings appear before you access the content, allowing you to make informed decisions. Additionally, detailed content ratings are available in each title's information page to help you understand what to expect."
    },
    {
      id: 4,
      question: "How extensive is your anime and manga database?",
      answer: "Our database is comprehensive and growing daily. We currently feature approximately 30,000 anime titles, 75,000 manga series, and 40,000 character profiles. Our team continually adds new content to ensure our library remains up-to-date with the latest releases and discoveries from anime history."
    },
    {
      id: 5,
      question: "Is there a mobile app available?",
      answer: "We're currently developing a native iOS app that will be available soon. In the meantime, our website is fully responsive and optimized for mobile browsers, allowing you to enjoy a seamless experience on any device."
    },
    {
      id: 6,
      question: "How often is new content added?",
      answer: "New content is added around the clock. Our team works continuously to update the database with new anime, manga, and character information as it becomes available. This ensures you always have access to the latest releases and information."
    },
    {
      id: 7,
      question: "How can I report bugs or suggest features?",
      answer: "We value your feedback! You can report issues or suggest improvements through our support form (coming soon). Your input helps us refine the site and create a better experience for the entire anime community."
    },
    {
      id: 8,
      question: "Can I import my anime/manga list from other tracking services?",
      answer: "Yes! We support importing lists from popular services like MyAnimeList. After creating an account, visit your profile settings to find the import option and follow the simple instructions to bring your existing lists into our platform."
    },
    {
      id: 9,
      question: "How accurate is your anime/manga information?",
      answer: "We strive for high accuracy in our database. Information is sourced from official channels, verified community contributions, and trusted industry sources. If you notice any inaccuracies, please let us know through our support form so we can correct it."
    },
    {
      id: 10,
      question: "Can I contribute to the site's content?",
      answer: "Absolutely! Community contributions are welcome and valued. Once you have an account, you can submit reviews, participate in discussions, and suggest edits to anime, manga, or character information. Our moderation team reviews contributions to maintain quality and accuracy."
    }
  ];

  return (
    <div className="faq-container">
      {/* New Title Section */}
      <div className="faq-page-title-container">
        <h1 className="faq-page-title">FAQ</h1>
        <p className="faq-page-subtitle">
          Find answers to common questions about our anime community platform
        </p>
      </div>
      
      <div className="faq-items">
        {faqItems.map(item => (
          <div 
            key={item.id} 
            className={`faq-item ${expandedItems[item.id] ? 'expanded' : ''}`}
          >
            <div 
              className="faq-question"
              onClick={() => toggleItem(item.id)}
            >
              <h3>{item.question}</h3>
              <span className="toggle-icon">
                {expandedItems[item.id] ? '−' : '+'}
              </span>
            </div>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="faq-footer">
        <h3>Still have questions?</h3>
        <p>If you couldn't find the answer you were looking for, please reach out to us.</p>
        <button className="contact-button">Contact Support</button>
      </div>
    </div>
  );
};

export default FAQ;